import React from 'react';
import Participant from './Participant';
import useParticipants from '../hooks/useParticipants';
import useMainParticipant from '../hooks/useMainSpeaker';
import useVideoContext from '../hooks/useVideoContext';
import useSelectedParticipant from './VideoProvider/useSelectedParticipant';

export default function ParticipantStrip(props) {
    const {room} = useVideoContext();
    const { participants, showWaitingMsg } = useParticipants();
    const [selectedParticipant, setSelectedParticipant] = useSelectedParticipant();
    const mainParticipant = useMainParticipant();
    if (participants.length === 0) return null; // Don't render this component if there are no remote participants.
    const stripParticipants = Array.from(room.participants.values()).concat(room.localParticipant).filter(participant => participant !== mainParticipant);
    return (
        <div className={`participant-strip`}>                
            {stripParticipants.map(participant => {
                    return (
                        participant.state === 'connected' && <Participant
                            key={participant.sid}
                            participant={participant}
                            isSelected={participant === selectedParticipant}
                            onClick={() => setSelectedParticipant(participant)}
                            isLocalParticipant={participant === room.localParticipant}
                        />
                    );
                })}               
            </div>        
    );
}
